import { render, staticRenderFns } from "./ShippingIntegration.vue?vue&type=template&id=9e1635a2&scoped=true"
import script from "./ShippingIntegration.vue?vue&type=script&lang=js"
export * from "./ShippingIntegration.vue?vue&type=script&lang=js"
import style0 from "./ShippingIntegration.vue?vue&type=style&index=0&id=9e1635a2&prod&scoped=true&lang=css"
import style1 from "./ShippingIntegration.vue?vue&type=style&index=1&id=9e1635a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1635a2",
  null
  
)

export default component.exports